import { objectKeyToString } from 'utils/object-key-to-string';

const crudActions = {
  CREATE: '',
  READ: '',
  UPDATE: '',
  UPSERT: '',
  DELETE: '',
};

const watchActions = {
  WATCH: '',
  UNWATCH: '',
  EMIT: '',
};

const snapshotActions = {
  SNAPSHOT: {
    TAKE: '',
    RESTORE: '',
    CLEAR: '',
  },
};

const permissionActions = {
  PERMISSIONS: {
    ADD_USER: '',
    REMOVE_USER: '',
    UPDATE_ROLE: '',
    UPDATE_EVERYONE_ROLE: '',
    UPDATE_LINK_SHARED: '',
  },
};

const actionTypes = objectKeyToString({
  ADMIN_SETTINGS: {
    GENERATE_EMBEDDING_KEY: '',
    FETCH_USAGE: '',
  },
  APP: {
    INIT: '',
    CONFIG: '',
    CLOUD_GROUP: '',
    FULLSCREEN: '',
    FORCE_RELOAD: '',
    SET_CLIENT_APP_ID: '',
    TENANT: {
      ...crudActions,
      ...watchActions,
    },
  },
  CACHE: {
    UPSERT_TOPOJSON: '',
    LOAD_TOPOJSON: '',
  },
  DASHBOARDS: {
    ...crudActions,
    ...permissionActions,
    REFRESH: '',
    DUPLICATE: '',
    FILTER: '',
    SORT: '',
    SHOW: '',
    SET_ERROR: '',
    UPDATE_LAYOUT: '',
    FETCH_DASHBOARDS_IF_NEEDED: '',
    EDIT: {
      OPEN: '',
      CLOSE: '',
      SAVE: '',
      DATA_SOURCE_PERMISSIONS: '',
    },
  },
  DASHBOARD_ITEMS: {
    ...crudActions,
    SYNC: '',
    DUPLICATE: '',
    MOVE: '',
    EMBED: '',
    BUILDER: {
      EDIT: '',
      SAVE: '',
      CANCEL: '',
      RESET: '',
      SET_DATA_SOURCE: '',
      SET_TITLE: '',
      FIELD_PANEL: {
        FILTER: '',
        REMOVE_VIRTUAL_FIELD: '',
        RESET_ADD_FIELD_PICKER: '',
        SAMPLE_DATA_SOURCE: '',
        SAVE_CONVERTED_FIELD: '',
        SAVE_MISSED_FIELD: '',
        SAVE_CALCULATED_FIELD: '',
      },
      RETRY_RENDER_PREVIEW: '',
      CHART: {
        APPLY_QUERY: '',
        CLEAR_CHANNEL: '',
        COPY_ENCODED_CHANNEL: '',
        MAP_FIELD_TO_CHANNEL: '',
        SELECT_AGGREGATE: '',
        SELECT_CHART_TYPE: '',
        SELECT_CHART_CATEGORY: '',
        SELECT_BINNING: {
          QUANTITATIVE: '',
          TEMPORAL: '',
        },
        TOGGLE_BINNING: '',
        SET_ARRAY_REDUCTION: '',
        SWAP_ENCODED_CHANNEL: '',
        MOVE_ENCODED_CHANNEL: '',
        SORT_CHANNEL: '',
        LIMIT_SORTABLE_CHANNEL: '',
        TOGGLE_SAMPLING: '',
        SET_CUSTOMISATION: '',
        SET_ZERO_STATE_MESSAGE: '',
        FETCH_PIPELINE: '',
        DOC_VIEW_DATA_CACHE: '',
        FETCH_DOCUMENTS: '',
        QUERY: {
          FILTER: '',
        },
        TABLE: {
          RESIZE_COLUMN: '',
          SORT_COLUMN: '',
        },
        GEOSPATIAL: {
          SET_ARRAY_COORDS_INDEX: '',
          SET_VIEWPORT: '',
          SET_MAP_LEGEND: '',
        },
        FIELD_FILTER: {
          ADD: '',
          TOGGLE: '',
          UPDATE: '',
          REMOVE: '',
          FETCH_VALUES: '',
        },
      },
    },
  },
  DATA_SOURCES: {
    ...crudActions,
    ...permissionActions,
    EDIT: {
      OPEN: '',
      CLOSE: '',
      SAVE: '',
    },
    EDIT_CONNECTION_STRING: {
      OPEN: '',
      CLOSE: '',
      EDIT: '',
      SAVE: '',
      TEST: '',
    },
    FILTER: '',
    SHOW: '',
    SET_URI: '',
    CONNECT_ON_PREM: '',
    CONNECT_CLOUD: '',
    DISCONNECT: '',
    GET_SERVER_INFO: '',
    IS_DATA_SOURCE_USED: '',
    LIST_DATABASES: '',
    LIST_COLLECTIONS: '',
    SELECT_CLUSTER: '',
    SELECT_DATABASE: '',
    SELECT_COLLECTION: '',
    CONFIGURE_READ_RULES: '',
    INCREMENT_WIZARD_STEP: '',
    DECREMENT_WIZARD_STEP: '',
    GO_TO_WIZARD_STEP: '',
    CLOSE_WIZARD: '',
    CANCEL_WIZARD: '',
    OPEN_WIZARD: '',
    EMBEDDING_OPTIONS: {
      OPEN: '',
      SAVE: '',
    },
    READ_PREFERENCE: {
      OPEN: '',
      SAVE: '',
    },
    PIPELINE: {
      OPEN: '',
      CLOSE: '',
      SAVE: '',
    },
    FETCH_CLUSTERS: '',
  },
  USER: {
    ...crudActions,
    CHANGE_PASSWORD: '',
    GET_STITCH_AUTH: '',
    SET_CLOUD_USER_DATA: '',
    LOGIN: '',
    LOGOUT: '',
  },
  USER_MANAGEMENT: {
    ...crudActions,
    FILTER: '',
    SEARCH: '',
    CLEAR_SEARCH_RESULTS: '',
    SORT: '',
    CHANGE_PASSWORD: '',
    UPSERT_USER_ROLE: '',
    UPSERT_USER_PROFILE: '',
  },
  ITEM_DATA_CACHE: {
    ...snapshotActions,
    READ: '',
    REFRESH: '',
    CLEAR_ERROR: '',
  },
  ADMIN: {
    LOGIN: '',
    LOGOUT: '',
  },
  DIALOG: {
    EDIT_PROFILE: '',
    CHANGE_PASSWORD: '',
    AUTO_REFRESH: '',
    MOVE_DASHBOARD_ITEM: '',
    EMBED_DASHBOARD_ITEM: {
      OPEN: '',
      CLOSE: '',
      FETCH_FIELDS: '',
      SAVE_FIELDS: '',
    },
    DELETE_DASHBOARD_ITEM: '',
    DELETE_DATASOURCE: {
      OPEN: '',
      CLOSE: '',
    },
    DATA_SOURCE_EMBEDDING_OPTION: '',
    DATA_SOURCE_READ_PREFERENCE: '',
    DELETE_DATASOURCE_PIPELINE: {
      OPEN: '',
      CLOSE: '',
    },
    VIEW_CHART_DATA: '',
    VIEW_CHART_PIPELINE: '',
    VIEW_CHART_DOCUMENTS: '',
  },
  SESSION: {
    INIT: '',
  },
  REFRESH: {
    HEARTBEAT: {
      START: '',
      STOP: '',
      TICK: '',
    },
    SETTINGS: {
      AUTO: {
        ENABLE: '',
        DISABLE: '',
      },
      UPDATE: {
        REFRESH_INTERVAL: '',
        TIME: '',
      },
      DELETE: '',
    },
    MANUAL: '',
    AUTO: '',
  },
  __DEV__: {
    HMR_CANCEL_SAGAS: '',
  },
});

export default actionTypes;
export { actionTypes };
